const btcPrice = (state = 65000, action) => {
  switch (action.type) {
      case 'SET_BTC_PRICE':
          return action.price
      default:
          return state
  }
}

export default btcPrice;